import React from "react";
import "./style.scss";
import { Link } from "react-router-dom";
import Html from "./Html";
import environment from "../../../environment";
import { useSelector } from "react-redux";

const Sidebar = ({ isOpen }) => {
  const user = useSelector((state) => state.user);

  const ListItemLink = ({ to, type = "link", disabled = false, ...rest }) => {
    let url = window.location.href;
    const host = window.location.host;
    url = url.split(host)[1];
    return (
      <>
        {type == "link" ? (
          <li
            className={`nav-item ${url.includes(to) ? "active" : ""} ${
              disabled ? "disabled" : ""
            }`}
          >
            {/* {...rest} */}
            <Link to={to} {...rest} className="" />
          </li>
        ) : (
          <li
            className={`nav-item main ${url.includes(to) ? "active" : ""}`}
            {...rest}
          ></li>
        )}
      </>
    );
  };

  const isAllow = (url = "") => {
    let permissions = user?.permissions?.[0];
    if (user?.role == environment.staffRoleId) {
      permissions = {
        readDashboard: true,
        readClock: true,
        readattendance: true,
        readShift: true,
        readCalendar: true,
        readchats: true,
        readBulletin: true,
      };
    }
    let arr = url.split(",");
    let value = false;
    arr.map((itm) => {
      if (permissions?.[itm]) value = permissions?.[itm];
    });

    if (!url || user?.role == "admin") value = true;
    return value;
  };

  return (
    <>
      <Html
        user={user}
        isAllow={isAllow}
        ListItemLink={ListItemLink}
        isOpen={isOpen}
      />
    </>
  );
};

export default Sidebar;
